"use client";
import { ProblemItem } from "@/app/actions/get-problems";
import { Interactions } from "@/components/interactions/interactions";
import { ThemeIllustration } from "@/components/theme-illustration";
import {
  Sheet,
  SheetContent,
  SheetDescription,
  SheetHeader,
  SheetTitle,
} from "@/components/ui/sheet";
import { Toaster } from "@/components/ui/sonner";
import { cleanString } from "@/lib/utils";
import { useRouter, useSearchParams } from "next/navigation";
import { useEffect, useState } from "react";
import { toast } from "sonner";
import { CommentArea } from "./comment-area";

type ProblemDrawerProps = {
  problem: ProblemItem;
  theme: string;
};

export function ProblemDrawer({ problem, theme }: ProblemDrawerProps) {
  const router = useRouter();
  const sp = useSearchParams();
  const { nome, descricao } = problem ?? { nome: "", descricao: "" };
  const [open, setOpen] = useState(false);
  const [back, setBack] = useState(false);
  const [openComment, setOpenComment] = useState(false);

  useEffect(() => {
    setOpen(true);
    const relato = sp.get("relato");
    if (relato) {
      setOpenComment(true);
    }
    const envio = sp.get("envio");
    if (envio && envio === "erro") {
      toast.error(
        "Erro ao enviar relato. Por favor, tente novamente mais tarde."
      );
    }
  }, [sp]);

  useEffect(() => {
    if (back) router.back();
  }, [router, back]);

  return (
    <Sheet
      open={open}
      onOpenChange={(isOpen: boolean) => {
        setOpen(isOpen);
        if (!isOpen) setBack(true);
      }}
    >
      <SheetContent
        side="bottom"
        className="xl:m-auto xl:rounded-t-2xl xl:container"
      >
        <div className="flex flex-col gap-3 px-7 pb-20 w-full">
          <SheetHeader className="px-0 border-card-header border-b-2 font-normal text-xs lg:text-sm">
            <SheetTitle className="flex justify-start items-center gap-2 w-full">
              <ThemeIllustration
                theme={theme}
                type="simple"
                width={42}
                height={42}
                className="aspect-square"
              />
              <div className="flex-1 font-normal text-xs lg:text-sm">
                {theme}
              </div>
            </SheetTitle>
          </SheetHeader>
          <div className="font-semibold text-sm lg:text-lg">{nome}</div>
          <SheetDescription className="font-normal text-xs lg:text-sm">
            {cleanString(descricao)}
          </SheetDescription>
          {!openComment && (
            <div className="gap-8 border-card-header border-t-2">
              <div className="max-w-90">
                <Interactions problem={problem} />
              </div>
            </div>
          )}
        </div>
        {openComment && <CommentArea problema={problem.id} />}
      </SheetContent>
      <Toaster position="bottom-center" theme="light" closeButton richColors />
    </Sheet>
  );
}
